export default {
  data() {
    return {
      debounceTimers: {}
    };
  },
  methods: {
    debounce(func, delay, name = 'debounce') {
      return (...args) => {
        clearTimeout(this.debounceTimers[name]);
        this.debounceTimers[name] = setTimeout(() => func.apply(this, args), delay);
      };
    }
  }
};
